import { Portal } from '../../Modal';
import type { Size } from '../../types';
import { Backdrop, type Props as BackdropProps } from '../Backdrop';
import type { Props as PopupProps } from '../Popup';
import { Popup } from '../Popup';

export interface Props extends PopupProps {
  children: React.ReactNode;
  size?: Size;
  backdropProps?: BackdropProps;
}

export const Content = ({
  children,
  size = 'md',
  backdropProps,
  ...props
}: Props) => {
  return (
    <Portal>
      <Backdrop {...backdropProps} />
      <Popup size={size} {...props}>
        {children}
      </Popup>
    </Portal>
  );
};
